'use client';

import * as React from 'react';
import { useState } from 'react';
import Button from './Button';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import Link from 'next/link';
import logEvent from '../helpers/mutations/logEvent';
import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import {
  REQUEST_INFO_LABEL,
  SCHEDULE_VIEWING_LABEL,
} from '@th/shared/src/constants/propertyInquiry';
import PropertyInquiryModal from './listingDetails/PropertyInquiryModal';
import { Agent } from '@th/shared/src/types/Agent';

type Props = {
  listing: SimpleListing;
  agent: Agent | null;
  isBlurred: boolean;
};

export default function PropertyInquiryMobileStickyButton({
  listing,
  agent,
  isBlurred,
}: Props) {
  const [isPropertyInquiryModalOpen, setIsPropertyInquiryModalOpen] =
    useState(false);

  return (
    <>
      <PropertyInquiryModal
        listing={listing}
        agent={agent}
        isOpen={isPropertyInquiryModalOpen}
        onClose={() => {
          setIsPropertyInquiryModalOpen(false);
        }}
      />
      <div className="sticky bottom-0 sm:hidden px-6 py-3 bg-background border-t-2 border-lightGray">
        {isBlurred ? (
          <Link href={'/auth/signup'} target="_blank">
            <Button
              title="Sign up"
              buttonClassName={'w-full'}
              onClick={() => {
                logEvent({
                  action:
                    AnalyticsEventAction.clicked_signup_button_in_sticky_footer,
                  type: AnalyticsEventType.signup_button_click,
                });
              }}
            />
          </Link>
        ) : (
          <Button
            title={
              listing.isActive() ? SCHEDULE_VIEWING_LABEL : REQUEST_INFO_LABEL
            }
            buttonClassName={'w-full'}
            onClick={() => {
              logEvent({
                action:
                  AnalyticsEventAction.clicked_property_inquiry_button_in_sticky_footer,
                type: AnalyticsEventType.property_inquiry_click,
              });
              setIsPropertyInquiryModalOpen(true);
            }}
          />
        )}
      </div>
    </>
  );
}
